import { css, Theme } from '@emotion/react'
import { alpha, buttonBaseClasses, formHelperTextClasses } from '@mui/material'
import { scaleBorderRadius } from 'theme/utils'

export const label = (theme: Theme) => css`
  font-weight: 400;
  color: ${theme.typographyColors.typographyThree};
`

export const row = (theme: Theme) => css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: ${theme.spacing(2, 0, 0)};
  padding: 9px 16px;
  border: 1px solid ${theme.backgrounds.backgroundOne};
  border-radius: ${scaleBorderRadius(theme.shape.borderRadius, 3.5)};
  box-shadow: 0px 2px 2px -1px ${alpha(theme.colors.typographyThree, 0.21)};
`

export const rowError = (theme: Theme) => css`
  border: 1px solid ${theme.colors.red};
`

export const textWrapper = css`
  display: flex;
  align-items: center;
  gap: 10px;
`

export const field = css`
  flex: 1;

  .${formHelperTextClasses.root} {
    display: block;
  }
`

export const iconButton = css`
  &.${buttonBaseClasses.root} {
    height: 36px;
    width: 36px;
    min-width: 36px;
    padding: 0;

    svg {
      height: 20px;
      width: 20px;
    }
  }
`

export const addContentButton = (theme: Theme) => css`
  margin-top: ${theme.spacing(2)};
  width: 100%;
`
